import { memo } from "react";
import { Flex, Popover, Tag } from "antd";

import IdentificationIcon from "@/icons/IdentificationIcon";
import PaperAirplaneIcon from "@/icons/PaperAirplaneIcon";
import DeviceTabletIcon from "@/icons/DeviceTabletIcon";

import { getFullName } from "@/utils";

const EmployeeField = ({ value }) => {
  if (!value) return null;

  const fields = [
    {
      key: "position",
      icon: IdentificationIcon,
      align: "start",
      text: value.position_name || "-",
    },
    {
      key: "email",
      icon: PaperAirplaneIcon,
      align: "center",
      text: value.secondary_email || "-",
    },
    {
      key: "phone",
      icon: DeviceTabletIcon,
      align: "center",
      text: value.phone || "-",
    },
  ];

  const hasPopoverContent = [
    value.position_name,
    value.secondary_email,
    value.phone,
  ].some(Boolean);

  const fullName = getFullName(
    value.lastname,
    value.firstname,
    value.patronymic,
  );

  const deleted = value.deleted;

  const content = (
    <Flex align="center" gap={6} style={{ minWidth: 0 }}>
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
          minWidth: 0,
        }}
      >
        {fullName}
      </span>

      {deleted && (
        <Tag color="red" style={{ flexShrink: 0 }}>
          Удален
        </Tag>
      )}
    </Flex>
  );

  const employeePopover = (
    <Flex vertical gap={1} style={{ color: "#777777", width: 200 }}>
      {fields.map(({ key, icon: Icon, align, text }) => (
        <Flex key={key} align={align} gap={6}>
          <Icon style={{ fontSize: 18, color: "#BBB" }} />
          {text}
        </Flex>
      ))}
    </Flex>
  );

  if (!hasPopoverContent) {
    return (
      content
    );
  }

  return (
    <Popover content={employeePopover} placement="bottom" arrow={false}>
      {content}
    </Popover>
  );
};

export default memo(EmployeeField);
